/**
 * @module actions/Volume
 */
import isNumber from 'lodash/isNumber';

import { VolumeActions } from '../constants/Volume';
import { getGlobalVolume } from '../lib/VolumeUtils';

/**
 * Sets the current global volume value. This is a generic value on a 100 point
 * scale. It is interpreted differently but shared by audio and video contexts.
 * It is also persisted and restored in local storage. The value must be between
 * 0 - 100 inclusive and a number. If not a number, the current volume value
 * in the store will be used. The volume applied will be clamped to the scale
 * and rounded to the nearest whole number.
 *
 * @param {number} value The value to set the volume to
 * @returns {Function} The action-thunk
 */
export function setGlobalVolume(value) {
  return (dispatch, getState) => {
    let volume = value;
    if (!isNumber(volume)) volume = getGlobalVolume(getState());
    volume = Math.round(Math.max(Math.min(100, volume), 0));
    return dispatch({
      type: VolumeActions.SET_VOLUME,
      data: {
        volume,
      },
    });
  };
}

/**
 * Sets the current global muted value.
 *
 * @param {boolean} mute true|false to set the current muted value
 * @returns {object} The action object.
 */
export function setGlobalMuted(mute = true) {
  return {
    type: VolumeActions.SET_MUTED,
    data: {
      muted: !!mute,
    },
  };
}
